import React from 'react';
import ScreenComponent from "../../components/screenComponent";
import {Get} from "../../components/request";
import screens from "../../screens";
import {withRouter} from "react-router-dom";

class FicheDescriptive extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            fiche: null,
            description: null
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const id = this.props.match.params.id;

        let {body} = await Get(`/v1/extranet/student/${screens.UEDetail}/${id}`);
        let fiche = body;

        ({body} = await Get(`/v1/extranet/student/${screens.FicheDescriptive}/${id}`));

        this.setState({
            fiche: fiche,
            description: body,
        })
    }

    renderFiche() {
        return (
            <>
                <p><b><u>Code de l'UE</u>: </b>{this.state.fiche.UniteEnseignementCode}</p>
                <p><b><u>Intitulé de l'UE</u>: </b>{this.state.fiche.UniteEnseignementLibelle}</p>
                <p><b><u>Nombre de crédits</u>: </b>{this.state.fiche.UniteEnseignementNombreECTS}</p>
                <p><b><u>Nombre d'heures</u>: </b>{this.state.fiche.UniteEnseignementNombreHeures}</p>
                <p><b><u>Langue d'enseignement</u>:
                </b>{this.state.fiche.UniteEnseignementCoursEnAnglais ? "Anglais" : "Français"}</p>
                <br/>
                <hr/>
                <h3>Objectifs et contribution de l'Unité d'Enseignement au programme</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursObjectifsEN && this.state.description.DescriptionCoursObjectifsEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursObjectifsFR && this.state.description.DescriptionCoursObjectifsFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
                <br/>
                <hr/>
                <h3>Prérequis et corequis</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursPrerequisEN && this.state.description.DescriptionCoursPrerequisEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursPrerequisFR && this.state.description.DescriptionCoursPrerequisFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
                <br/>
                <hr/>
                <h3>Description du contenu</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursContenuEN && this.state.description.DescriptionCoursContenuEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursContenuFR && this.state.description.DescriptionCoursContenuFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
                <br/>
                <hr/>
                <h3>Méthodes pédagogiques</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursPedagogieEN && this.state.description.DescriptionCoursPedagogieEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursPedagogieFR && this.state.description.DescriptionCoursPedagogieFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
                <br/>
                <hr/>
                <h3>Mode d'évaluation</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursTypeEvaluationEN && this.state.description.DescriptionCoursTypeEvaluationEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursTypeEvaluationFR && this.state.description.DescriptionCoursTypeEvaluationFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
                <br/>
                <hr/>
                <h3>Références bibliographiques</h3>
                <br/>
                <p>
                    {this.state.fiche.UniteEnseignementCoursEnAnglais
                        ? this.state.description.DescriptionCoursReferencesEN && this.state.description.DescriptionCoursReferencesEN.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })
                        : this.state.description.DescriptionCoursReferencesFR && this.state.description.DescriptionCoursReferencesFR.split("\n").map((m, index) => {
                        return (index === 0) ? m : [<br key={index}/>, m]
                    })}
                </p>
            </>
        );
    }

    render() {
        return (
            <section>
                {this.state.fiche != null && this.renderFiche()}
            </section>
        );
    }
}

export default withRouter(FicheDescriptive);